var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7719 3.52298C10.7719 5.18436 9.42508 6.53118 7.7637 6.53118C6.10233 6.53118 4.75551 5.18436 4.75551 3.52298C4.75551 1.8616 6.10233 0.514789 7.7637 0.514789C9.42508 0.514789 10.7719 1.8616 10.7719 3.52298Z",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.931921
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28139 12.2092C1.28139 11.7925 1.49211 11.3907 1.92595 11.0024C2.36245 10.6116 2.98931 10.2693 3.71906 9.98986C4.93764 9.52319 6.35755 9.26355 7.44489 9.21397C7.2442 10.1077 7.08983 11.8011 8.16252 13.4803H1.68397C1.46361 13.4803 1.28139 13.2981 1.28139 13.0777V12.2092Z",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.931921
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7049 12.287C17.2085 11.4299 17.4549 10.3906 17.2192 9.26561C16.8549 7.50847 15.3764 6.10491 13.5978 5.87991C10.7799 5.51562 8.40137 7.88347 8.77637 10.7013C9.01208 12.4799 10.4049 13.9585 12.1621 14.3227C13.2871 14.5585 14.3264 14.312 15.1835 13.8085L17.1763 15.8013C17.3767 16.0016 17.6484 16.1142 17.9317 16.1142C18.215 16.1142 18.4867 16.0016 18.6871 15.8013C18.8874 15.601 18.9999 15.3293 18.9999 15.046C18.9999 14.7626 18.8874 14.4909 18.6871 14.2906L16.7049 12.287ZM13.0299 12.2656C11.8514 12.2656 10.8871 11.3013 10.8871 10.1228C10.8871 8.94419 11.8514 7.9799 13.0299 7.9799C14.2085 7.9799 15.1728 8.94419 15.1728 10.1228C15.1728 11.3013 14.2085 12.2656 13.0299 12.2656Z",
    fill: "#858585",
    stroke: "white",
    strokeWidth: 0.919691
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.bc85aa0e7ae21fe0838323cc8b52377d.svg";
export { ForwardRef as ReactComponent };